<template>
    <div class="speaker-card">
        <MktCardHand class="speaker-card__hand" event-theme>
            <PrismicImage :field="speaker.image" />
        </MktCardHand>
        <div>
            <PrismicRichText class="speaker-card__name" :field="speaker.name" />
            <p class="speaker-card__job">{{ speaker.jobTitle }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {PrismicRichText, PrismicImage} from '@prismicio/vue';
    import type {SpeakersSliceDefaultPrimarySpeakersItem} from '@prismicio-types';
    import {MktCardHand} from '#components';

    defineProps<{speaker: SpeakersSliceDefaultPrimarySpeakersItem}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    $max_width: 440px;
    $card_width: 219px;
    $card_height: 274px;

    .speaker-card {
        text-align: center;
        border-radius: var(--joy-core-radius-4);
        width: 100%;
        max-width: 300px;

        &__hand {
            margin: 0 auto var(--joy-core-spacing-6);
            user-select: none;
        }
        &__name {
            color: var(--joy-color-text-heading);
            font-size: var(--joy-font-size-secondary-200);
            font-weight: var(--joy-font-weight-bold);
            position: relative;
            margin-top: -35px;

            &,
            strong {
                font-family: var(--joy-font-family-title);
                font-weight: var(--joy-font-weight-normal);
            }
        }
        &__job {
            margin-top: var(--joy-core-spacing-2);
            color: var(--joy-color-neutral-40);
            font-size: 18px;
        }
    }
</style>
